import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Header } from '@/widgets/header'
import { Footer } from '@/widgets/footer'
import { OnboardingFloatingCta } from '@/widgets/onboarding-floating-cta'
import { designTokens } from '@/shared/lib/design-tokens'
import bgOnboarding from '@/shared/assets/onboarding/bg_onboarding.png'
import { routes } from '@/shared/config'
import { OnboardingOldPageDesktop } from './onboarding-old-page-desktop'
import { OnboardingOldPageMobile } from './onboarding-old-page-mobile'

const supportBotUrl = 'https://t.me/ps24supportbot'
const telegramBotUrl = 'https://t.me/epicgrowth_com_bot'

const openSupportBot = () => window.open(supportBotUrl, '_blank', 'noopener,noreferrer')

const openTelegramBot = () => window.open(telegramBotUrl, '_blank', 'noopener,noreferrer')

export function OnboardingOldPage() {
  const navigate = useNavigate()
  const floatingCtaRef = useRef<HTMLDivElement | null>(null)
  const panelRef = useRef<HTMLDivElement | null>(null)
  const [floatingCtaHeight, setFloatingCtaHeight] = useState<number | null>(null)
  const [shouldFlattenPanel, setShouldFlattenPanel] = useState(false)
  const handleDashboardRedirect = () => navigate(routes.dashboardLk)

  useLayoutEffect(() => {
    const element = floatingCtaRef.current
    if (!element) {
      return
    }
    const observer = new ResizeObserver((entries) => {
      const entry = entries[0]
      if (!entry) {
        return
      }
      setFloatingCtaHeight(entry.contentRect.height)
    })
    observer.observe(element)
    return () => observer.disconnect()
  }, [])

  useEffect(() => {
    const updatePanelState = () => {
      if (!panelRef.current) {
        return
      }
      const panelRect = panelRef.current.getBoundingClientRect()
      const viewportBottom = window.innerHeight - (floatingCtaHeight ?? 0)
      const panelTallerThanViewport = panelRect.height > viewportBottom
      setShouldFlattenPanel(panelRect.bottom > viewportBottom || panelTallerThanViewport)
    }

    updatePanelState()

    window.addEventListener('scroll', updatePanelState, { passive: true })
    window.addEventListener('resize', updatePanelState)
    return () => {
      window.removeEventListener('scroll', updatePanelState)
      window.removeEventListener('resize', updatePanelState)
    }
  }, [floatingCtaHeight])

  return (
    <section
      className="flex min-h-screen w-full flex-col"
      style={{
        backgroundColor: designTokens.colors.background.page,
        backgroundImage: `url(${bgOnboarding})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
      }}
    >
      <Header className="hidden lg:flex" />
      <main className="flex w-full flex-1 flex-col items-center">
        <OnboardingOldPageDesktop
          onDashboardRedirect={handleDashboardRedirect}
          onTelegramBot={openTelegramBot}
        />
        <OnboardingOldPageMobile
          panelRef={panelRef}
          floatingCtaHeight={floatingCtaHeight}
          shouldFlattenPanel={shouldFlattenPanel}
        />
      </main>
      <div
        className="hidden w-full lg:flex"
        style={{
          maxWidth: designTokens.components.footer.maxWidth,
          margin: '0 auto',
        }}
      >
        <Footer onRightClick={openSupportBot} />
      </div>
      <div ref={floatingCtaRef} className="fixed bottom-0 left-0 w-full lg:hidden">
        <OnboardingFloatingCta
          onPrimaryClick={openTelegramBot}
          onSecondaryClick={handleDashboardRedirect}
        />
      </div>
    </section>
  )
}
